import endpoints from '../endpoints.ts';
import { HydratedEpcisSgtin } from '../types/compoundModels';
import { fetch } from './helpers.ts';
import type { EpcisMedVocabulary, EpcisSgtin } from '../types/models.ts';
import { PaginationOptions, WithPagination } from '../types/types.ts';

export namespace OrderAPI {
  export namespace Request {
    export interface ReadManySearch {
      customerId: number | string;
      senderName: string;
      purchaseOrderNumber: string;
      docDateStart: string;
      docDateEnd: string;
    }
  }

  export namespace Response {
    export interface ReadManySearch {
      amountNotReceived: number;
      amountReceived: number;
      contentType: string;
      customerLocationName: string;
      documentId: number;
      globalLocationNumber: string;
      md5Hash: string;
      timestamp: string;
      meds: (EpcisSgtin & { epcisMedVocabulary: EpcisMedVocabulary })[];
      purchaseOrderNumbers: string[];
      senderNames: string[];
    }
  }
}

const order = {
  read: {
    many: {
      search: async (params: {
        filters: OrderAPI.Request.ReadManySearch;
        paginationOptions?: PaginationOptions;
      }): Promise<WithPagination<OrderAPI.Response.ReadManySearch> | null> => {
        const url = endpoints.order.read.many.search();
        return await fetch<WithPagination<OrderAPI.Response.ReadManySearch>>(
          url,
          'GET',
          {
            ...params.filters,
            ...params.paginationOptions,
          }
        );
      },
    },
    all: {
      meds: {
        by: {
          documentId: async (
            documentId: number | string
          ): Promise<HydratedEpcisSgtin[] | null> => {
            const url = endpoints.order.read.all.meds.by.documentId();
            return await fetch<HydratedEpcisSgtin[]>(url, 'GET', {
              documentId,
            });
          },
        },
      },
    },
  },
};

export default order;
